import { useModalContext } from "../../contexts/ModalContext"

const ModalBackdrop = ({ cssBackdrop = "", children = null }) => {

    const { closeModal } = useModalContext()

    const backdropCss = `fixed w-screen h-screen top-0 left-0 bg-backdropGrey flexJustifyItemsCenter z-30 ${cssBackdrop}`

    return (
        <div onClick={closeModal} className={backdropCss}>
            {children}
        </div>
    )
}

export default ModalBackdrop